import { render, staticRenderFns } from "./PlantingHole.vue?vue&type=template&id=4fa23912"
import script from "./PlantingHole.vue?vue&type=script&lang=js"
export * from "./PlantingHole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports